// src/components/features/timetables/Legend/TimetableLegend.tsx
import { SvgIcon } from '../../../base/Icon/SvgIcon';
import styles from './TimetableLegend.module.css';

export function TimetableLegend() {
  return (
    <section className={styles.legend} aria-label="Timetable legend">
      <div className={styles.entry}>
        <SvgIcon name="pickUpOnly" size={16} />
        <span className={styles.label}> = Pick up only</span>
      </div>
      <div className={styles.entry}>
        <SvgIcon name="setDownOnly" size={16} />
        <span className={styles.label}> = Set down only</span>
      </div>
    </section>
  );
}
